import React from 'react';
import {
  Embed,
  Header,
} from 'semantic-ui-react';

const Donations = ({ user }) => {
  return (
    <React.Fragment>
      <Header as='h2' inverted>Donations</Header>
      <p>
        The Donation system allows you to setup donations that go directly to your PayPal account. Twitching of Isaac does not take a cut of this transaction, and all
        donations go directly to you. If you have previously used StreamLabs for accepting donations, you should be familiar with the options available in configuring
        your account. The big differentiator with this Donation system, is that when you are online with the mod, any incentives that you have setup will be automatically
        shown on your public Donation page.
      </p>
      <Header as='h3' inverted>Currencies</Header>
      <p>
        You can specify a default currency that you want to accept donations in. The currency list is based off of the PayPal accepted currency list, and unfortunately
        any missing currencies would be due to lack of support on the PayPal side.
      </p>
      <Header as='h3' inverted>PayPal Fees & Minimum Amount</Header>
      <p>
        PayPal charges a fee for all transactions that you receive. The Donation page will help you understand what the fee is for your selected currency, so that you
        can set appropriate minimum donation amounts. The public donation page also makes the PayPal fee visible to the person making the donation; and they are offered
        the opportunity to cover the PayPal fee as part of their donation, so that you can receive the full value of the donation they intended to make.
      </p>
      <Header as='h3' inverted>Twitch Authentication</Header>
      <p>
        You have the option to require donators to be authenticated via Twitch. This will allow you to know who the donator was. When disabled, the user is prompted
        to enter a name in a text input field. Currently, this only impacts seeing who made the donation in your donation history, however, in the future there will
        also be a stream widget to show donations on your Stream which will display the username and a message - having the username in place is a deterrent to
        trolling and inappropriate content from showing up on your stream. It is also useful as a deterrent to charge backs or disputes of donations.
      </p>
      <Header as='h3' inverted>Incentives</Header>
      <p>
        Incentives are a great way to provide milestones for donations. Each donation incentive has a minimum donation amount, that will unlock as an incentive on
        the donation page when someone enters in a donation. They will also be shown additional incentives that could be unlocked if they increase their donation.
        You don't have to have Incentives set up to use the donation system, and they will only show up on the public donation page if you are actively logged in to
        the mod.
      </p>
      <p>
        Incentives, when redeemed as part of a donation, will trigger a command within the game. It is important to note that commands triggered in this manner will
        bypass all limits set on a command, for example cooldown limits, banned items, or even if the command is disabled or subscriber only - this is intentional, so
        that donations can activate a command that you perhaps have limited in other ways.
      </p>
      <p>
        For example, you have banned the ability for the <strong>!spawn</strong> command to spawn Bloat. When creating a new incentive, you would specify the minimum
        donation amount you would like to receive for having to deal with a spawned in Bloat. The Action dropdown will show you all of your custom commands, as well
        as publically available commands. In this example, we would select <strong>Spawn</strong>. In the Action Parameters input field, we would enter <strong>Bloat</strong>,
        which would mimic a chat input of <em>!spawn bloat</em>. Even though you have banned Bloat as a spawnable enemy in the command configuration for <strong>!spawn</strong>,
        the donation redeem will bypass this ban and allow this command to run successfully.
      </p>
      <Embed
        url='/images/support-donation-spawn-bloat.webm'
        active={true}
      />
      <br />
      <p>
        As soon as a donation is successfully completed on the public donation page, the action will be sent immediately to the game to activate.
      </p>
    </React.Fragment>
  )
};

export default Donations;
